import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';
import { Box, View } from '@common/components';
import { doAction } from '@resources/Action/actions';
import { connect } from 'react-redux';
import { getCookie, setCookie } from '@common/utils/cookie';
import { setNavigation } from '@resources/Navigation/actions';
import { door00 } from '../assets/images';
import { updateMember } from '@resources/Member/actions';
import { isEmpty } from 'lodash';
import { setAudio } from '@resources/Audio/actions';

const Intro = ({
  match,
  clues,
  socket,
  setNavigation,
  history,
  updateMember,
  setAudio,
}) => {
  const u = getCookie('user') ? JSON.parse(getCookie('user')) : {};
  const location = 'Intro';
  const { params } = match || {};
  const { channelId } = params;
  const video = getCookie('video') ? JSON.parse(getCookie('video')) : false;

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname === `/batavia-express/${channelId}/play/intro`
    ) {
      if (!isEmpty(socket)) {
        doAction({
          game: 'batavia-express',
          channel: socket.channel,
          event: 'member',
          message: {
            id: socket.id,
            name: u.name,
            location: location,
            game: 'batavia-express',
          },
        });
        doAction({
          game: 'batavia-express',
          channel: socket.channel,
          event: 'log',
          message: {
            id: socket.id,
            name: u.name,
            location: location,
            channel: channelId,
            message: `has moved to ${location}`,
            game: 'batavia-express',
          },
        });
        updateMember({ id: socket.id, name: u.name, location });
        // doAction({
        // 	channel: socket.channel,
        // 	event: 'clues',
        // 	message: clues,
        // });
      }
    }
  }, [socket, history]);

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname === `/batavia-express/${channelId}/play/intro`
    ) {
      setNavigation({
        backward: null,
        forward: video && {
          image: door00,
          title: 'Hallway',
          onPress: () => {
            setAudio(true);
            history.push(`/batavia-express/${channelId}/play/fork`);
          },
        },
      });
    }
  }, [clues, video, history]);

  return (
    <View>
      <Box centered textAlign="center">
        <ReactPlayer
          url="https://youtu.be/XYuWEORosuc"
          playing
          width="100%"
          height="80%"
          onPlay={() => {
            doAction({
              game: 'batavia-express',
              channel: socket.channel,
              event: 'log',
              message: {
                id: socket.id,
                name: u.name,
                location: location,
                channel: channelId,
                message: `is watching the ${location}`,
                game: 'batavia-express',
              },
            });
            setAudio(false);
          }}
          onEnded={() => {
            setAudio(true);
            setCookie('video', JSON.stringify(true));
            doAction({
              game: 'batavia-express',
              channel: socket.channel,
              event: 'log',
              message: {
                id: socket.id,
                name: u.name,
                location: location,
                channel: channelId,
                message: `has finised watching the ${location}`,
                game: 'batavia-express',
              },
            });
            history.push(`/batavia-express/${channelId}/play/fork`);
          }}
        />
      </Box>
    </View>
  );
};

const mapStateToProps = (state) => ({
  puzzles: state.puzzles,
  socket: state.socket,
  clues: state.clues,
});

export default connect(mapStateToProps, {
  doAction,
  setNavigation,
  updateMember,
  setAudio,
})(Intro);
